import React from 'react';

export default function Blank() {
  return (<></>);
}